export default ({ tours = null, hotelOffers = null, rooms = [] }) => {
    const roomsIndex = _.indexBy(rooms, 'id');
    const productEntity = tours?.length
        ? tours
        : hotelOffers;

    _.each(productEntity, (product) => {
        const roomCategoryId = product.room.id;
        const standartCategory = roomsIndex[roomCategoryId];
        if (roomCategoryId && standartCategory) {
            product.room = {
                ...product.room,
                ...standartCategory,
            };
        }
    });

    return productEntity;
};
